import { render, staticRenderFns } from "./ColorsInput.vue?vue&type=template&id=fb6acf92&scoped=true&"
import script from "./ColorsInput.vue?vue&type=script&lang=js&"
export * from "./ColorsInput.vue?vue&type=script&lang=js&"
import style0 from "./ColorsInput.vue?vue&type=style&index=0&id=fb6acf92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6acf92",
  null
  
)

export default component.exports